import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIconCustomDumbbell({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M.5 12.5c-.276 0-.5-.373-.5-.833V8.333c0-.46.224-.833.5-.833s.5.373.5.833v3.334c0 .46-.224.833-.5.833zM19.5 12.5c-.276 0-.5-.373-.5-.833V8.333c0-.46.224-.833.5-.833s.5.373.5.833v3.334c0 .46-.224.833-.5.833zM17.5 5.545c-.175 0-.343.04-.5.11v-.746C17 3.857 16.327 3 15.5 3S14 3.857 14 4.91v4.454H6V4.909C6 3.857 5.327 3 4.5 3S3 3.857 3 4.91v.745a1.202 1.202 0 00-.5-.11c-.827 0-1.5.857-1.5 1.91v5.09c0 1.053.673 1.91 1.5 1.91.175 0 .343-.04.5-.11v.746C3 16.144 3.673 17 4.5 17S6 16.143 6 15.09v-4.454h8v4.455c0 1.053.673 1.909 1.5 1.909s1.5-.857 1.5-1.91v-.745c.157.071.325.11.5.11.827 0 1.5-.857 1.5-1.91v-5.09c0-1.053-.673-1.91-1.5-1.91zm-15 7.637c-.276 0-.5-.285-.5-.636V7.455c0-.352.224-.637.5-.637s.5.285.5.637v5.09c0 .352-.224.637-.5.637zM5 15.09c0 .351-.224.636-.5.636s-.5-.285-.5-.636V4.909c0-.351.224-.636.5-.636s.5.285.5.636v10.182zm11 0c0 .351-.224.636-.5.636s-.5-.285-.5-.636V4.909c0-.351.224-.636.5-.636s.5.285.5.636v10.182zm2-2.545c0 .35-.224.636-.5.636s-.5-.285-.5-.636V7.455c0-.352.224-.637.5-.637s.5.285.5.637v5.09z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIconCustomDumbbell;
